import { CheckIcon, MonitorIcon, MoonIcon, SunIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme, type ThemeMode } from "@/hooks/use-theme";
import { cn } from "@/lib/utils";

const OPTIONS: { mode: ThemeMode; labelKey: string; icon: typeof SunIcon }[] = [
  { mode: "light", labelKey: "theme.light", icon: SunIcon },
  { mode: "dark", labelKey: "theme.dark", icon: MoonIcon },
  { mode: "system", labelKey: "theme.system", icon: MonitorIcon },
];

export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={className} aria-label={t("theme.toggle")}>
          <SunIcon className="size-4.5 scale-100 rotate-0 transition-transform dark:scale-0 dark:-rotate-90" />
          <MoonIcon className="absolute size-4.5 scale-0 rotate-90 transition-transform dark:scale-100 dark:rotate-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {OPTIONS.map(({ mode, labelKey, icon: Icon }) => (
          <DropdownMenuItem key={mode} onSelect={() => setTheme(mode)}>
            <Icon className="size-4" />
            {t(labelKey)}
            <CheckIcon className={cn("ml-auto size-4", theme !== mode && "opacity-0")} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
